/**
 * 用户相关控制器
 *
 * 默认流程（created）：
 * 1. 页面加载自动调用 UCLogin & fetchUserInfo - 判断是否已有登录态，若没有则进2、3
 * 登录流程（login）：
 * 2. doRequestSmsCode & doDelay - 请求发送短信验证并延迟
 * 3. login - 请求登录
 * 领课流程（doReceive）：查看 receive.js
 */

import { Toast } from 'vant'
import sasdk from './sasdkinit'
import cookie from 'js-cookie'
import { sendSmsCode, loginByCode, drainageSignUp } from '@/api/common'
import { getReferrer, recordStudentActivation } from '@/api/landingpage'
import { updateStudentInfo } from '@/api/account'

import '@/utils/gt'
import { isPhone } from '@/utils/vilidate'

var timemeter

export default {
    data () {
        return {
            user: {
                /** 用户相关仕途状态 */
                view: {
                    /** 输入的手机号 */
                    inputmobile: '',
                    /** 输入的短信验证码 */
                    inputcode: ''
                },
                /** 鉴权相关状态 */
                auth: {
                    /** 是否正在请求验证码接口 */
                    requestingCode: false,
                    /** 是否可以重发短信 */
                    resendCode: false,
                    /** 延迟时间 */
                    delay: 0,
                    /** 是否已登录 */
                    logged: false
                },
                /** 用户（家长）信息 */
                info: {
                    /** 用户（家长） ID */
                    id: undefined,
                    /** 手机号 */
                    mobile: undefined,
                    /** 姓名 */
                    name: undefined,
                    /** 已注册时长 */
                    registerDays: undefined,
                    /** 是否下过数学正价单 */
                    hadMathOrder: undefined
                },
                headers: {}
            }
        }
    },
    async created () {
        const parentId = this.getParentID()
        const Authorization = cookie.get('Authorization')

        if (parentId && Authorization) {
            try {
                await this.UCLogin()
                await this.fetchUserInfo()
            } catch (e) {
                Toast.clear(true)
            }
        }
    },
    methods: {
        /**
         * （登录后）获取并更新用户信息
         */
        async fetchUserInfo () {
            const parentId = this.getParentID()
            if (!parentId) return

            let { data } = await getReferrer({
                parentId
            })

            this.user.info.id = data.id
            this.user.info.mobile = data.mobile
            this.user.info.name = data.name
            this.user.info.registerDays = data.registerDays
            this.user.info.hadMathOrder = data.hadMathOrder
            this.user.auth.logged = true

            return data
        },
        /**
         * 利用 UC 侧 Token 快速登录
         */
        async UCLogin () {
            let response = await drainageSignUp({
                appId: this.appId,
                channelId: this.channelId,
                channelKeyword: this.channelKeyword,
                birthday: new Date()
            })

            if (response.code === 0 && response.data.id) {
                let parentid = response.data.id
                cookie.set('mathparentid', parentid)
                cookie.set('cookie_id', parentid)
                sasdk.registerPage({
                    student_id: '',
                    parent_id: parentid
                })
            } else {
                throw new Error('登录态不存在或已过期')
            }
        },
        /**
         * 请求登录短信验证码接口
         */
        doRequestSmsCode () {
            if (this.user.view.inputmobile) {
                if (!isPhone(this.user.view.inputmobile, 'CN')) {
                    Toast('请输入正确的手机号码')
                    return
                }
            } else {
                Toast('请输入您的手机号')
                return
            }
            if (this.user.auth.requestingCode) {
                return
            }
            this.user.auth.requestingCode = true
            Toast.loading({
                message: '加载中...',
                forbidClick: true
            })
            sendSmsCode(
                {
                    username: this.user.view.inputmobile,
                    type: 1,
                    appId: this.appId,
                    function: 'login',
                    channelId: this.channelId,
                    channelKeyword: this.channelKeyword
                },
                this.headers
            )
                .then(res => {
                    this.user.auth.requestingCode = false
                    Toast.clear()
                    if (res.data.code === 0) {
                        this.resendCode = true
                        this.doDelay()
                    } else {
                        Toast(res.data.msg)
                    }
                })
                .catch(err => {
                    Toast.clear()
                    this.user.auth.requestingCode = false
                    if (err && err.response && err.response.status === 410) {
                        if (this.captchaObj) {
                            this.captchaObj.verify()
                        } else {
                            // 初始化极验组件
                            var headers = err.response.headers
                            var gtinfo = (this.gtinfo = {
                                gt: headers['vk-gt'],
                                challenge: headers['vk-gt-challenge'],
                                initsuccess: headers['vk-gt-initsuccess'],
                                newcaptcha: headers['vk-gt-newcaptcha']
                            })
                            // eslint-disable-next-line no-undef
                            initGeetest(
                                {
                                    // 以下 4 个配置参数为必须，不能缺少
                                    gt: gtinfo.gt,
                                    challenge: gtinfo.challenge,
                                    offline: gtinfo.initsuccess === 'false', // 表示用户后台检测极验服务器是否宕机
                                    new_captcha: gtinfo.newcaptcha === 'true', // 用于宕机时表示是新验证码的宕机

                                    product: 'bind', // 产品形式，包括：float，popup
                                    width: '300px'

                                    // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
                                },
                                captchaObj => {
                                    this.captchaObj = captchaObj
                                    captchaObj
                                        .onReady(() => {
                                            captchaObj.verify()
                                        })
                                        .onSuccess(() => {
                                            const result = captchaObj.getValidate()
                                            this.headers = {
                                                'vk-gt-challenge': result.geetest_challenge,
                                                'vk-gt-validate': result.geetest_validate,
                                                'vk-gt-seccode': result.geetest_seccode,
                                                'vk-gt-type': 2
                                            }
                                            this.doRequestSmsCode()
                                        })
                                    //
                                }
                            )
                        }
                    } else if (err && err.response && err.response.status === 400) {
                        if (err.response.data && err.response.data.msg) {
                            let msg = ''
                            switch (err.response.data.msg) {
                                case 'VERIFY_CODE_SEC_REPEAT':
                                    msg = '操作太过频繁，请稍后重试！'
                                    break
                                case 'PARAMETER_ERROR':
                                    msg = '请输入正确的手机号码！'
                                    break
                                case 'VERIFY_CODE_SEND_ERROR':
                                    msg = '验证码发送失败，请重试！'
                                    break
                                case 'MOBILE_INVALID':
                                    msg = '请输入正确的手机号码！'
                                    break
                                default:
                                    msg = '验证码发送失败，请重试！'
                                    break
                            }
                            // this.user.view.inputcodeerrormsg = msg
                            Toast(msg)
                        }
                    }
                })
        },
        /**
         * 验证码登录
         */
        async login () {
            if (!this.user.view.inputcode.trim()) {
                Toast('请输入短信验证码')
                return false
            }
            Toast.loading({
                message: '加载中...',
                forbidClick: true
            })

            var loginResponse

            try {
                loginResponse = await loginByCode({
                    username: this.user.view.inputmobile,
                    verifyCode: this.user.view.inputcode,
                    channelKeyword: this.channelKeyword,
                    channelId: this.channelId,
                    appId: this.appId
                })
            } catch (e) {
                if (e && e.response && e.response.status === 400) {
                    if (e.response.data && e.response.data.msg) {
                        let msg =
                            {
                                VERIFY_CODE_SEC_REPEAT: '操作太过频繁，请稍后重试！',
                                PARAMETER_ERROR: '手机号或验证码错误',
                                VERIFY_CODE_ERROR: '验证码错误',
                                VERIFY_CODE_EXPIRED: '验证码过期'
                            }[e.response.data.msg] || '登录异样'
                        Toast(msg)
                    }
                }
                return false
            }

            if (loginResponse.status === 200 && loginResponse.data.code === 0) {
                cookie.set('Authorization', loginResponse.data.data.token)
                try {
                    await this.UCLogin()
                    await this.fetchUserInfo()
                } catch (e) {
                    Toast('用户信息获取失败，请重试')
                }
                return true
            } else {
                return false
            }
        },
        /**
         * 进行短信延迟
         */
        doDelay () {
            this.user.auth.delay = 60
            var current = new Date().getTime()
            clearInterval(timemeter)
            timemeter = setInterval(() => {
                var now = new Date().getTime()
                var delay = 60 - Math.floor((now - current) / 1000)
                if (delay < 0) {
                    clearInterval(timemeter)
                } else {
                    this.user.auth.delay = delay
                }
            }, 1000)
        },
        /**
         * 记录学生激活
         */
        async recordStudentActivation (studentId) {
            var parentId = this.getParentID()

            let selectedGrade = this.receive.gradeInfo.gradeList[this.receive.gradeInfo.selectedGradeIndex]

            try {
                await recordStudentActivation({
                    activityCode: this.activityCode,
                    channelId: this.channelId,
                    channelKeyword: this.channelKeyword,
                    parentId,
                    studentId,
                    grade: selectedGrade.grade
                })
            } catch (e) {}

            try {
                await updateStudentInfo({
                    studentId,
                    grade: selectedGrade.grade
                })
            } catch (e) {}

            // getStudentInfo({ studentId })
            //     .then(response => {
            //         let data = response.data
            //         console.log(data)
            //         if (response.code !== 200) {
            //             Toast('领取失败，请联系客服。')
            //             return
            //         }
            //         this.displaySelectStudent = false
            //         if (data.hadMathOrder || data.hadTrialOrder) {
            //             this.$emit('received', false)
            //         } else {
            //             // location.href = {
            //             //     3: '//mobile.vipkid.com.cn/shop/spread/sp_414a96b1',
            //             //     4: '//mobile.vipkid.com.cn/shop/spread/sp_3c9c8ecf',
            //             //     5: '//mobile.vipkid.com.cn/shop/spread/sp_48bda933'
            //             // }[this.selectedGradeIndex]
            //             this.$emit('received', true)
            //         }
            //     })
            //     .catch(e => {
            //         console.log(e)
            //     })
        }
    }
}
